/*
*
* File JS per la Homepage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSlider from 'imComponents/hero-slider/hero-slider';

import blockScrollCarousel from 'components/block-scroll-carousel/block-scroll-carousel';

import blockTextTwoImg from 'components/block-text-two-img/block-text-two-img';

import blockTextOneImg from 'components/block-text-one-img/block-text-one-img';

import blockBannerFull from 'components/block-banner-full/block-banner-full';

import cardExperience from 'components/card-experience/card-experience';

import blockExperience from 'components/block-experience/block-experience';

import blockOffers from 'components/block-offers/block-offers';

import blockMagazine from 'components/block-magazine/block-magazine';

import blockGalleryOffScreen from 'components/gallery-off-screen/gallery-off-screen';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

heroSlider();

blockScrollCarousel();

blockExperience();

blockOffers();

blockGalleryOffScreen();

//--------------------------------------------------------------------//